module.exports = __webpack_public_path__ + "files/90039d43c79435a970fd84a267cbfd15.png";